import React from "react";
import { useMutation } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";
import { postPatient } from "../../../../../services/PatientService";
import { useNotification } from "../../../../../context/NotificationProvider";
import { useLocalization } from "../../../../../context/LocalizeContextProvider";
import { useAuth } from "../../../../../context/AuthProvider";
import { checkRmNumber } from "../../../../../services/Handlers/PatientService";
import FormPatient from "../../Components/FormPatients";
import { formatPatientDobForApi } from "../../../../../utils/patientDob";
import { safeGoBack } from "../../../../utils/navigation";

export default function AddPatient() {
  const history = useHistory();
  const notification = useNotification();
  const localize = useLocalization();
  const { userDetail } = useAuth();
  const [isCheckingRm, setIsCheckingRm] = React.useState(false);

  const { isLoading: isLoadingSubmit, mutate: mutateSubmit } = useMutation(
    postPatient,
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          notification.success(localize.getText("successAddData"));
          // Defer navigation one tick so notistack can mount the snackbar
          // before the route changes.
          setTimeout(() => safeGoBack(history, "/patient"), 0);
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
      },
    }
  );

  const handleSubmitForm = async (value) => {
    if (value.medicalRecordNumber) {
      setIsCheckingRm(true);
      try {
        const rmCheck = await checkRmNumber({
          businessId: userDetail?.businessId,
          rmNumber: value.medicalRecordNumber,
        });
        setIsCheckingRm(false);
        if (rmCheck.data && rmCheck.data.exists) {
          notification.error(
            rmCheck.data.message || "Nomor rekam medis sudah digunakan"
          );
          return;
        }
      } catch (error) {
        setIsCheckingRm(false);
        notification.error(localize.getText("unknownMessageError"));
        return;
      }
    }

    const alergiesDTOs = value.allergies.map((item) => ({
      ...item,
      ...(item.__isNew__ ? {} : { __isNew__: false }),
    }));

    const data = {
      ...value,
      allergy: alergiesDTOs,
      dob: formatPatientDobForApi(value.dateOfBirth),
      dateOfBirth: formatPatientDobForApi(value.dateOfBirth),
    };
    mutateSubmit(data);
  };

  return (
    <FormPatient
      handleSubmitForm={handleSubmitForm}
      isLoadingSubmit={isLoadingSubmit || isCheckingRm}
    />
  );
}
